const IndustriesSection = () => {
  const traits = [
    "Clients trust you with significant decisions",
    "Referrals built your business, but you need more pipeline",
    "You've avoided outbound because most of it feels off-brand",
    "Compliance matters in how you communicate"
  ];

  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="py-20 md:py-32 px-5 md:px-12 lg:px-20 bg-[#050505] border-t border-white/5"
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-20">
          <div>
            <p className="text-[#6DBE2E] text-[11px] md:text-xs font-medium tracking-[0.2em] uppercase mb-4 md:mb-6">
              Fit
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium text-white leading-tight tracking-tight mb-6 md:mb-8">
              Trust is the product.
            </h2>
            
            <p className="text-white/50 text-base md:text-lg leading-relaxed">
              We work best with companies where reputation drives revenue. 
              If that's you, we should talk.
            </p>
          </div>

          <div className="lg:pt-8">
            <div className="space-y-0">
              {traits.map((trait, i) => (
                <div 
                  key={i} 
                  className="flex items-start gap-4 py-4 border-b border-white/5"
                >
                  <span className="text-[#6DBE2E] text-lg mt-0.5">→</span>
                  <p className="text-white/70 text-sm md:text-base">{trait}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
